import React, { useContext } from 'react';
import { Button } from 'baseui/button';

import { ModalContext } from 'commons-ui';

import usePermissionV2 from 'commons-ui/src/permission/usePermission';
import { ACTION, PAGE_NAMES, USER_PROFILE_RESOURCES } from 'constant';
import GetTransactionHistoryFilterContent from './GetTransactionHistoryFilterContent';

const GetTransactionHistory = (props: any) => {
	const { setModalConfig } = useContext(ModalContext);
	const { handleFilterSubmit } = props;

	const { hasPermission: hasPermissionV2 } = usePermissionV2();

	const handleGetTransactionHistory = async () => {
		setModalConfig({
			isOpen: true,
			header: 'Get Transaction History',
			content: <GetTransactionHistoryFilterContent handleFilterSubmit={handleFilterSubmit} />
		});
	};

	return hasPermissionV2({
		configPageName: PAGE_NAMES.userProfile,
		configResourceName: USER_PROFILE_RESOURCES.transactionHistory,
		configActionName: ACTION.getTransactionDetails
	}) ? (
		<Button onClick={handleGetTransactionHistory} size='compact'>
			Get Transaction History
		</Button>
	) : (
		<> </>
	);
};

export default GetTransactionHistory;
